<div class="modal fade show d-block " tabindex="-1" role="dialog" aria-labelledby="error-modal-title"
  aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Seriale</h5>
        <button class="chiudi" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group form-row col-lg-12">
          <div class="col-lg-6">
            <label>Nome Prodotto</label>
            <input class="form-control" type="text" [(ngModel)]="seriale.prodotto">
          </div>
          <div class="col-lg-6">
            <label>Quantità</label>
            <input class="form-control" min=1 type="number" [(ngModel)]="seriale.quantita">
          </div>
        </div>
        <div class="form-group form-row col-lg-12">
          <div class="col-lg-6">
            <label>Seriale</label>
            <input class="form-control" type="text" [(ngModel)]="seriale.seriale">
          </div>
          <div class="col-lg-6">
            <label>Data di Acquisto</label>
            <input type="date" class="form-control" [(ngModel)]="seriale.dataAcquisto">
          </div>
        </div>
        <div class="col-12">
          <app-field-viewer [Campi]="campi" [(Oggetto)]="seriale"></app-field-viewer>
        </div>

      </div>
      <div class="modal-footer">
        <ng-container *ngFor="let button of Azioni">
          <button type="submit" type="button" [ngClass]="button['class']" [ngbTooltip]="button.placeholder ?? ''"
            (click)='customButton(Item,button)'>
            <i *ngIf="button['icon']" [ngClass]="button['icon']" class="font-14 mr-1 text-white"></i>
            <span [ngClass]="button['labelClass']"> {{ button['nome'] | translate }} </span>
          </button>
        </ng-container>
        <button type="submit" (click)="save()" style="margin: 0.75px;"
          class=" btn btn-success  waves-effect waves-light">
          <span class="mr-1 text-white "> Salva </span>
          <i class="far fa-save text-white"></i>
        </button>
        <button type="submit" (click)="save(true)" style="margin: 0.75px;"
          class=" btn btn-success  waves-effect waves-light">
          <span class="mr-1 text-white "> Salva e chiudi </span>
          <i class="far fa-save text-white"></i>
        </button>
        <button type="submit" (click)="closeModal()" style="margin: 0.75px;"
          class=" btn btn-danger  waves-effect waves-light">
          <span class="mr-1 text-white "> Chiudi </span>
          <i class="far fa-window-close text-white"></i>
        </button>
      </div>
    </div>
  </div>
</div>